import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  Output,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmailconfirmationModalComponent } from '../emailconfirmation-modal/emailconfirmation-modal.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { LoaderService } from 'src/app/services/loader.service';
import { CustomValidators } from 'src/app/shared/validators/custom.validator';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword-modal.component.html',
  styleUrls: ['./forgotpassword-modal.component.scss'],
})
export class ForgotpasswordModalComponent {
  isDisableGetOTPBtn = false;

  // #region INPUT, OUTPUT, VIEWCHILD
  @Input() modalRef: any;
  @Output()
  onGetOtpClick = new EventEmitter<any>();

  @ViewChild('forgotPasswordModal')
  forgotPasswordTemplate!: TemplateRef<ForgotpasswordModalComponent>;
  @ViewChild('emailConfirmationModal')
  emailConfirmationComponent!: EmailconfirmationModalComponent;

  // #endregion
  private modalService = inject(NgbModal);
  constructor(
    private authService: AuthService,
    private loaderService: LoaderService,
    private toastr: ToastrService

  ) {}
  email: string = '';

  formGroup = new FormGroup({
    Email: new FormControl('', [Validators.required, CustomValidators.emailValidator()]),
  });

  openEmailConfirmationModal(
    event: any,
    emailConfirmationModal: TemplateRef<any>
  ) {
    this.fromGroupTouched(true);
    if (this.formGroup.invalid) return;
    this.loaderService.setLoading(true);

    this.email = this.formGroup.get('Email').value;
    this.isDisableGetOTPBtn = true;
    //API call for GET OTP
    this.authService.getOTP(this.email).subscribe((res: string) => {
      if (!res) {
        this.authService.userEmail$.next(this.email);
        this.modalRef.close();
        this.formReset();
        this.isDisableGetOTPBtn = false;
        this.toastr.success("OTP sent successfully");
        this.modalRef = this.modalService.open(emailConfirmationModal, {
          windowClass: 'project-modal email-confirmation-Modal',
          centered: true,
          backdropClass: 'primary-backdrop',
        });
      } else {
        this.isDisableGetOTPBtn = false;
      }
      this.loaderService.setLoading(false);
    });
  }

  enterKeyPress(event) {
    /** Note - keycode 13 mining Enter key */
    if (event.keyCode === 13) {
      this.openEmailConfirmationModal(
        '',
        this.emailConfirmationComponent.emailconfirmationTemplate
      );
    }
  }

  onTextValueChange(field) {
    this.fromGroupTouched();
    this.email = field.value;
  }

  fromGroupTouched(isSubmitted: boolean = false) {
    if (this.formGroup.touched || isSubmitted) {
      this.formGroup.markAllAsTouched();
      this.formGroup.updateValueAndValidity();
    }
  }

  formReset() {
    this.email = '';
    this.formGroup.reset();
    this.formGroup.updateValueAndValidity();
  }
}
